module.exports = __webpack_public_path__ + "img/744.ce40a4c9.jpg";